var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.landingPageFlag
        ? _c("div", { staticClass: "landingPage" }, [
            _c("div", { staticClass: "landingPage-top" }, [
              _c("div", { staticClass: "landing" }, [
                _vm._m(0),
                _vm._m(1),
                _c(
                  "div",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        return _vm.goSubscribe("add")
                      },
                    },
                  },
                  [_c("span", [_vm._v("前往订阅")])]
                ),
              ]),
            ]),
            _vm._m(2),
          ])
        : _vm._e(),
      _c("subscribe-drawer", { ref: "subscribeDrawer" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "bigTitle" }, [
      _vm._v("全网商机实时推送"),
      _c("br"),
      _vm._v("商机开发快人一步"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "des" }, [
      _vm._v(
        "Real time push of business opportunities throughout the network,"
      ),
      _c("br"),
      _vm._v("One step faster in business opportunity development"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "landingPage-bottom" }, [
      _c("div", { staticClass: "lpGuide lpGuide-01 clearfix" }, [
        _c("div", { staticClass: "img lf" }, [
          _c("img", {
            attrs: { src: require("@/assets/subscribe/landing-02.png") },
          }),
        ]),
        _c("div", { staticClass: "txt rt" }, [
          _c("p", { staticClass: "bigTitle" }, [
            _vm._v("多种商机可订阅，精准覆盖拓客场景"),
          ]),
          _c("div", { staticClass: "des" }, [
            _c("p", [_vm._v("新成立的企业")]),
            _c("p", [_vm._v("新增ICP的企业")]),
            _c("p", [_vm._v("新建网站的企业")]),
            _c("p", [_vm._v("新增招投标的企业")]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "lpGuide lpGuide-02 clearfix" }, [
        _c("div", { staticClass: "txt lf" }, [
          _c("p", { staticClass: "bigTitle" }, [
            _vm._v("针对不同商机配置偏好，精细化定义商机客群"),
          ]),
        ]),
        _c("div", { staticClass: "img rt" }, [
          _c("img", {
            attrs: { src: require("@/assets/subscribe/landing-03.png") },
          }),
        ]),
      ]),
      _c("div", { staticClass: "lpGuide lpGuide-03 clearfix" }, [
        _c("div", { staticClass: "img lf" }, [
          _c("img", {
            attrs: { src: require("@/assets/subscribe/landing-04.png") },
          }),
        ]),
        _c("div", { staticClass: "txt rt" }, [
          _c("p", { staticClass: "bigTitle" }, [
            _vm._v("实时分析满足条件的商机，开发业务快人一步"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }